import styles from "./styles.module.scss";

interface NegotiationCostRangeProps {
  fromCost: number;
  toCost: number;
}

export function NegotiationCostRange({
  fromCost,
  toCost,
}: NegotiationCostRangeProps) {
  return (
    <div className={styles.negotiationCostRange}>
      <span className={styles.negotiationCostFrom}>₹{fromCost}</span>
      <span className={styles.negotiationCostArrow} aria-hidden>
        →
      </span>
      <span className={styles.negotiationCostTo}>₹{toCost}</span>
    </div>
  );
}
